export default function AdminCard({ children, className = "" }) {
  return (
    <div
      className={`
        relative
        bg-gray-900/80
        border border-green-500/30
        rounded-2xl
        shadow-lg shadow-green-500/20
        backdrop-blur-xl
        ${className}
      `}
    >
      <div className="absolute inset-0 rounded-2xl border border-green-500/20 pointer-events-none" />

      <div className="relative">
        {children}
      </div>
    </div>
  );
}